import "core-js/stable";
import { datadogRum } from '@datadog/browser-rum';
import React, { Fragment } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from './components/Error/ErrorBoundary';
import ErrorDisplay from "./components/Error/ErrorDisplay";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import "./index.scss";
import App from "./App";
import navReducer from "./store/reducers/nav";
import newsReducer from "./store/reducers/news";
import originReducer from "./store/reducers/origin";
import homeReducer from "./store/reducers/home";
import productsReducer from "./store/reducers/products";
import manualsReducer from "./store/reducers/manuals";
import formsReducer from "./store/reducers/forms";
import featuresReducer from "./store/reducers/product-feature";
import upcomingShowsReducer from "./store/reducers/upcomingShows";
import articlesReducer from "./store/reducers/articles";
import bannersReducer from "./store/reducers/banners";
import literatureReducer from "./store/reducers/literature";
import fieldadjustmentReducer from "./store/reducers/fieldadjustment";
import searchReducer from "./store/reducers/search";
import serialReducer from "./store/reducers/serial";
import BrowserChecker from "./hoc/BrowserCheck/BrowserChecker";
import dealerIntReducer from "./store/reducers/dealerInt";
import divisionsReducer from "./store/reducers/divisions";
import facilitiesReducer from "./store/reducers/facilities";
import locationsReducer from "./store/reducers/locations";
import authReducer from "./store/reducers/auth";
import authAgronomy from "./store/reducers/agronomy";
import financeReducer from "./store/reducers/finance";
import partsmartReducer from "./store/reducers/partsmart"

// initialize DataDog error tracking/reporting if not in local environment.
if (import.meta.env.CLIENT_NODE_ENV !== 'local') {
  datadogRum.init({
    applicationId: '007cb870-7280-4f28-be35-56d6ee7644d8',
    clientToken: 'pubf40616d8f2d2135825e4b88eef7d0ebb',
    site: 'us3.datadoghq.com',
    service: 'greatplainsag-website',
    env: import.meta.env.CLIENT_NODE_ENV,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

console.warn = () => {};
// const composeEnhancers =
//   import.meta.env.CLIENT_NODE_ENV === "development"
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//     : null || compose;
const composeEnhancers = compose;

const rootReducer = combineReducers({
  home: homeReducer,
  nav: navReducer,
  news: newsReducer,
  origin: originReducer,
  products: productsReducer,
  articles: articlesReducer,
  banners: bannersReducer,
  manuals: manualsReducer,
  upcomingShows: upcomingShowsReducer,
  literature: literatureReducer,
  features: featuresReducer,
  search: searchReducer,
  forms: formsReducer,
  fieldAdjustment: fieldadjustmentReducer,
  dealerInt: dealerIntReducer,
  serial: serialReducer,
  facilities: facilitiesReducer,
  divisions: divisionsReducer,
  locations: locationsReducer,
  auth: authReducer,
  agronomy: authAgronomy,
  finance: financeReducer,
  partsmart: partsmartReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={store}>
    <BrowserChecker debug={false} />
    <ErrorBoundary fallback={<ErrorDisplay/>}>
      <BrowserRouter>
        <Fragment>
          <App />
        </Fragment>
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>
);


createRoot(document.getElementById("root")).render(app);
